import React, { useEffect, useState, useCallback } from "react";
import Line from "../../main/Line";
import BackButton from "../../main/BackButton";
import axios from "../../../axios-backend";
import Button from "../../main/Button";
import { Link, useLocation } from "react-router-dom";

const ViewOptions = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [options, setOptions] = useState([]);

  const getData = useCallback(() => {
    axios
      .get("/all-options", {
        params: { stepsId: id },
      })
      .then((data) => {
        setOptions(data.data.data);
      });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const mapAndRenderOptions = () => {
    return options.map((item, index) => {
      return (
        <Line type="bottom-line" key={index}>
          {item.index}: {item.content}
          <Link
            style={{ marginLeft: "2rem" }}
            to={`/edit-option?id=${item.id}`}
          >
            <Button>Edit</Button>
          </Link>
          <Link
            style={{ marginLeft: "2rem" }}
            to={`/add-option-img?id=${item.id}`}
          >
            <Button>Upload Option Image</Button>
          </Link>
        </Line>
      );
    });
  };

  return (
    <>
      <BackButton />
      <Line type="bottom-line">
        <Link to={`/edit-option?sid=${id}`}>
          <Button> Add New Option </Button>
        </Link>
      </Line>
      {options == null ? null : mapAndRenderOptions()}
    </>
  );
};

export default ViewOptions;
